import React, { PureComponent } from 'react'
import { Platform, View, TextInput } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import GenericRadioSelection from '../GenericRadioSelection'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  padding: ${3 * theme.gutterUnit}px ${3 * theme.gutterUnit}px ${theme.gutterUnit}px ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.white};
`

const HostnameInput = styled(TextInput)`
  width: 100%;
  border-color: ${theme.colours.black};
  border-width: 1px;
  margin: ${theme.gutterUnit}px 0;
  padding: ${theme.gutterUnit}px;
  justify-content: flex-start;
  align-items: flex-start;
`

const Row = styled(View)`
  flex-direction: row;
  flex-wrap: wrap;
`

const SectionWrapper = styled(View)`
  width: 30%;
`
export default class HostSelection extends PureComponent {
  render () {
    const {
      newHostname,
      onHostNameChange,
      hostType,
      onHostTypeChange,
      hostEnv,
      onHostEnvChange,
      hostRole,
      onHostRoleChange
    } = this.props
    const textAlignVertical = Platform.select({ android: { textAlignVertical: 'top' }, default: {} })
    return (
      <Container>
        <Text bold>GAME SERVER ADDRESS</Text>
        <Row>
          <SectionWrapper>
            <GenericRadioSelection
              boxWidth='200px'
              checkboxes={[{
                handleClick: () => onHostTypeChange('online'),
                checked: hostType === 'online',
                label: 'Online'
              }, {
                handleClick: () => onHostTypeChange('offline'),
                checked: hostType === 'offline',
                label: 'Offline'
              }, {
                handleClick: () => {
                  onHostTypeChange('manual')
                  if (process.env.REACT_NATIVE_HOST_IP_ADDR) {
                    onHostNameChange(`http://${process.env.REACT_NATIVE_HOST_IP_ADDR}:3000`)
                  }
                },
                checked: hostType === 'manual',
                label: 'Manual'
              }]}
            />
          </SectionWrapper>
          {hostType !== 'manual' && (
            <SectionWrapper>
              <GenericRadioSelection
                boxWidth='200px'
                checkboxes={[{
                  handleClick: () => onHostEnvChange('live'),
                  checked: hostEnv === 'live',
                  label: 'Live'
                }, {
                  handleClick: () => onHostEnvChange('testing'),
                  checked: hostEnv === 'testing',
                  label: 'Testing'
                }]}
              />
            </SectionWrapper>
          )}
          {hostType === 'offline' &&
            <SectionWrapper>
              <GenericRadioSelection
                boxWidth='200px'
                checkboxes={[{
                  handleClick: () => onHostRoleChange('primary'),
                  checked: hostRole === 'primary',
                  label: 'Primary Server'
                }, {
                  handleClick: () => onHostRoleChange('secondary'),
                  checked: hostRole === 'secondary',
                  label: 'Secondary Server'
                }]}
              />
            </SectionWrapper>}
        </Row>
        <HostnameInput
          onChangeText={(val) => onHostNameChange(val)}
          autoCorrect={false}
          value={newHostname}
          returnKeyType='done'
          maxLength={250}
          disabled={hostType !== 'manual'}
          {...textAlignVertical}
        />
      </Container>
    )
  }
}
